export default "__VITE_ASSET__DBnOmW83__"